import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-sort-icon',
    templateUrl: './sort-icon.component.html',
    styleUrls: ['./sort-icon.component.scss']
})
export class SortIconComponent extends AbstractIcon {
    constructor() {
        super();
        this.height = 24;
        this.width = 30;
    }
}
